import { configureStore } from '@reduxjs/toolkit';
import refreshExpiredReducer from './slices/refreshExpiredReducer';
import loginSliceReducer from './slices/login';
import currentUserStateReducer from './slices/currentUserState';
import walletsSliceReducer from './slices/walletsSlice';

import { layoutAPI } from '../layout/services/services';
import { userAPI } from '../pages/settings/services/user';
import { authenticationApi } from '../pages/login/services/authenticationApi';
import { componentAPI } from '../components/services/services';
import { transactionListAPI } from '../pages/transactions/services';
import { transferAPI } from '../pages/transfer/services/services';
import { cardActionAPI } from '../pages/cards/services/services';
import { approvalAPI } from '../pages/approvals/services/approvalService';
import { authorizationAPI } from '../services/authorization';
import { fastOutGoingMessagesAPI } from '../pages/fast/services/services';

const store = configureStore({
  reducer: {
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [layoutAPI.reducerPath]: layoutAPI.reducer,
    [userAPI.reducerPath]: userAPI.reducer,
    [componentAPI.reducerPath]: componentAPI.reducer,
    [transactionListAPI.reducerPath]: transactionListAPI.reducer,
    [transferAPI.reducerPath]: transferAPI.reducer,
    [cardActionAPI.reducerPath]: cardActionAPI.reducer,
    [approvalAPI.reducerPath]: approvalAPI.reducer,
    [authorizationAPI.reducerPath]: authorizationAPI.reducer,
    [fastOutGoingMessagesAPI.reducerPath]: fastOutGoingMessagesAPI.reducer,
    login: loginSliceReducer,
    refreshExpired: refreshExpiredReducer,
    currentUserState: currentUserStateReducer,
    walletsSlice: walletsSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authenticationApi.middleware)
      .concat(layoutAPI.middleware)
      .concat(userAPI.middleware)
      .concat(componentAPI.middleware)
      .concat(transactionListAPI.middleware)
      .concat(transferAPI.middleware)
      .concat(cardActionAPI.middleware)
      .concat(approvalAPI.middleware)
      .concat(authorizationAPI.middleware)
      .concat(fastOutGoingMessagesAPI.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
